import dotget from "./helpers/dotJsonGetter";

export default {
    currentScript: null,
    base: {
        default_base_url: 'https://app.partnero.com',
        share_form_page_type: 'newsletter_program_share_form'
    },
    get(setting, def) {
        return dotget(this.base, setting, def);
    },
    getCurrentScript() {
        return this.currentScript;
    },
    setCurrentScript(script) {
        this.currentScript = script;
        return this;
    },
    getCurrentScriptQueryParam(param, def) {

        def = def ?? undefined;
        let value = null;

        const scriptElement = this.getCurrentScript();
        if (scriptElement) {
            const src = scriptElement.getAttribute('src');
            const queryString = src.split('?')[1];
            const params = new URLSearchParams(queryString);
            value = params.get(param);
        }

        return value ?? def;
    }
}
